import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { BookingConfirm } = await import('@containers/Payment/BookingConfirm');
    return {
        Component: BookingConfirm,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
